import { BranchType } from "../delivery-company/branches";

export interface OrderRoute {
    id: number;
    order_pk: number;
    version: number;
    branch_ids: number[];
    branches: BranchType[];
    total_minutes: number | null;
    algorithm: string;
    computed_at: string;
    legs: OrderRouteLeg[];
}

export enum OrderRouteLegStatus {
    AWAITING = "awaiting",
    STARTED = "started",
    FINISHED = "finished"
}

export interface OrderRouteLeg {
    position: number
    source: BranchType
    destination: BranchType
    travel_minutes: number | null
    status: OrderRouteLegStatus
}